import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import Api from '@/api'

Vue.use(Vuex)


export default new Vuex.Store({
  state: {
    cartList: {},//购物车列表
    cartDetail: {},//满送金额
    latitude: '',//纬度
    longitude: '',//经度
    loglatcity: '',
    navHeight: 0,//返回的导航高度
    address: {},//下单时的收货地址
    cuponNum: 0,//可使用优惠券个数
    pocketNum: 0,//可使用红包个数
    cuponMoney: 0,//优惠券金额
    pocketMoney: 0,//红包金额
    cupon: {},//使用的优惠券
    pocket: {},//使用的红包  
    storeId: null,//当前店铺id
    orderOrgId: 0,//美食提交订单是的店铺id
    searchOrgId: 0,//搜索时候需要的店铺id
    orderResMsg: {},//请求订单接口返回的订单详情信息 
    distribution: 0,//配送金额
    orderType: 0,//订单类型 1美食 2食材
    newSession: false,//是否有新的sessionid,
    isLogin:null,//判断登录状态
    collectToPage: false,//收藏跳去详情（详情样式要发生变化）
    searchBack: false,//检测是否从搜索页返回
    hasSearchKey: '',//已搜索的值
    city: 0,//原生传来的城市id
    // storeAddress: '',//店铺地址
    // storeTel: '',//店铺电话
    sendType: 3,//
    selfTake:2,
    distance: 0 ,//美食的距离
    addList: false,//是否为再来一单
    addListAddressDetail: {},
    choseShopDetail: {},//净菜选了的到店自取的门店
		textareaValue:'',
		vegetableSelectTime:"",


    isClicked:0
  },
  getters: {
    longitude: state=> state.longitude,
    latitude: state => state.latitude,
    loglatcity: state=> state.loglatcity,
    cuponNum: state => state.orderResMsg.couponNum,
    cuponMoney: state => state.orderResMsg.couponAmount,
    pocketNum: state => state.orderResMsg.pocketMoneyNum,
    pocketMoney: state => state.orderResMsg.pocketMoneyAmount,
    distribution: state => state.orderResMsg.distributionAmount,
  },
  mutations: {
// 		setTextareaValue(state,textareaValue) {
// 		  state.textareaValue = textareaValue;
// 			console.log('textareaValue',textareaValue)
// 		},
		
    setStoreId(state,id) {
      state.storeId = Number(id)
    },
    setInitCart(state, payload) {
      // console.log('test cartArray', payload)
      let cart = {};
      cart[payload.oid] = cart[payload.oid] || {}
      let shop = cart[payload.oid] || {}
      payload.cartArray.forEach((val,index) => {
        val.num = val.buyNum
        shop[val.spuId] =  {'detail': val}
        // console.log('3333333333',shop[val.spuId],cart)
      });
      let detail = {}
      detail = payload.UTsend
      state.cartList = {...cart}
      state.cartDetail = {...detail}
    },
    addCart(state, data) {
      let cart = state.cartList;
      cart[data.shopid] = cart[data.shopid] || {}
      let shop = cart[data.shopid] || {};
      // console.log('shop', shop)
      if (shop[data.spuId]) {
        // console.log('此时的num', shop[data.spuId]['detail']['num'])
        shop[data.spuId]['detail']['num']++
      } else {
        data.num = 1
        shop[data.spuId] = {
          detail: data
        }
      }
      state.cartList = { ...cart }
    },
    deleteCart(state, data) {
      // console.log('正在删除',data)
      let cart = state.cartList
      let shop = cart[data.shopid]
      if (shop[data.spuId]['detail']['num']) {
        shop[data.spuId]['detail']['num']--
        if (!shop[data.spuId]['detail']['num']) {
          delete shop[data.spuId]
        }
      }
      state.cartList = { ...cart }
    },
    deleteAll(state, data) {
      // console.log('正在删除',data)
      let cart = state.cartList
      let shop = cart[data.shopid]
      // if (shop[data.spuId]['detail']['num']) {
      //   shop[data.spuId]['detail']['num']--
      //   if (!shop[data.spuId]['detail']['num']) {
      //   console.log('删除的商品',data.detail.spuId)
      delete shop[data.detail.spuId]
      // console.log('ssssssssss',cart)
      //   }
      // }
      state.cartList = { ...cart }
    },
    clearCart(state, data) {
      let cart = state.cartList
      delete cart[data]
      state.cartList = { ...cart }
    },
    getCartDetail(state, data) {
      state.cartDetail = data
    },
    setLatLog(state, { latitude, longitude }) {
      state.latitude = latitude
      state.longitude = longitude
    },
    setCity(state,data) {
      // console.log('收到城市',data)
      state.city = Number(data)
    },
    setNavHeight(state, height) {
      state.navHeight = height
    },
    setAddress(state, obj) {
      // console.log('setAddress',obj)
      state.address = obj
    },
    setCupon(state, obj) {
      state.cupon.id = obj.id;
      state.cupon.totalAmount = obj.totalAmount;
    },
    setPocket(state, obj) {
      state.pocket.id = obj.id;
      state.pocket.totalAmount = obj.totalAmount;
    },
    // setCuponNum(state, data) {
    //   state.cuponNum = Number(data)
    // },
    // setPocketNum(state, data) {
    //   state.pocketNum = Number(data)
    // },
    setOrderOrgId(state, data) {
      state.orderOrgId = Number(data)
    },
    setSearchOrgId(state, data) {
      state.searchOrgId = Number(data)
    },
    getOrderResMsg(state, data) {
      // console.log('getOrderResMsg',data)
      state.orderResMsg = data
    },
    setOrderType(state, data) {
      // console.log('此时的订单类型是',data)
      state.orderType = Number(data)
    },
    getNewSession(state,data) {
      // console.log('是否有新的sessionid',data)
      state.newSession = data
      // location.reload()
    },
    changeState(state,flag){
      console.log('是否为登录状态',flag)
			state.isLogin=flag
		},
    setCollectToPage(state, flag) {
      // console.log('收藏页跳详情',flag)
      state.collectToPage = flag
    },
    setSearchBack(state, flag) {
      // console.log('搜索页返回到首页',flag)
      state.searchBack = flag
    },
    setSearchKey(state, data) {
      // console.log('不是返回首页，是跳其他页面',data)
      state.hasSearchKey = data
    },
    setSendType(state, data) {
      state.sendType = Number(data)
    },
    setSelfTake(state, data) {
      state.selfTake = Number(data)
    },
    setDistance(state,data) {
      state.distance = Number(data)
    },
    setAddList(state,flag) {
      state.addList = flag
    },
    setAddListAddressDetail(state,obj) {
      state.addListAddressDetail = {...obj}
    },
    setChoseShopDetail(state,obj) {
      state.choseShopDetail = {...obj}
    },

    setIsClicked(state,data){
      state.isClicked = Number(data)
    }
  },
  actions: {
    getInitCart({
      commit
    }, param) {
      // console.log('ssssssssssss',param)
      Api.CartDetails(param).then(response => {
        if (response.q.s == 0) {
          // console.log('购物车详情',response.q)
          commit('setSelfTake',response.q.shops[0].selfTake)
          let cartArray = []
          cartArray = cartArray.concat(response.q.shops['0']['cartInfos'])
          let trueCart = []
          cartArray.forEach((val,index)=> {
            if(val.isInvalid !==1) {
              let price = val.discountPrice / val.buyNum
              val.discountPrice = price
              trueCart.push(val)
            }
          })
          if(!param.orgId) {
            param.orgId=0
          }
          let oid = param.orgId
          let UTsend = {
            UTsend: response.q.UTsend,
            difference: response.q.difference,
            distribution: response.q.distribution,
            ifUTsend: response.q.ifUTsend
          }
          let all = {
            oid,
            cartArray:trueCart,
            UTsend
          }
          commit('setInitCart', all)
        }
      })
    },
    getOrderSubmit({
      state,
      commit
    }, status) {
      // console.log('是否已拿到地址status',status)
      if(status) {
        let oid = state.orderOrgId
        let addresId = state.address.id
        let cart = {}
        let cartList = []
        let goodsList = []
        let distribution = null
        let type = 2
        if(oid) {
          type = 1
        }
        cart = state.cartList[oid]
        distribution = state.cartDetail.distribution
        Object.keys(cart).forEach((val,index)=> {
          cartList.push(cart[val])
        })
        cartList.forEach((val,index)=> {
          // console.log('val val val',val)
          if(val.detail.isInvalid!=1) {
              goodsList.push({skuId: val.detail.skuId, spuId: val.detail.spuId, num: val.detail.num, promId: val.detail.promId})
          }
        })
        // console.log('getOrderSubmit cart',cart)
        let params = {
          a: 2,
          type: type,
          sendType: state.sendType,
          goodsList: goodsList,
          distribution: distribution,
          addresId: addresId
        }
        if(type == 1) {
          params.orgId = oid
          if(Object.keys(state.cupon).length) {
            params.coupons = String(state.cupon.id)
          }
        }
        if(Object.keys(state.pocket).length) {
          params.pocketMoney = Number(state.pocket.id)
        }
        // console.log('拿到地址后购物车试算参数',params)
        Api.OrderSubmit(params).then(response => {
          if(response.q.s == 0) {
            // let couponNum = response.q.couponNum
            // let pocketNum = response.q.pocketMoneyNum
            // commit('setCuponNum',couponNum)
            // commit('setPocketNum',pocketNum)
            commit('getOrderResMsg',response.q)
          }
        })
      }
    },
    changeLogin({
			commit
		},flag){//调用changeState 函数 异步执行
			commit('changeState',flag)
		},
  }
})



// WEBPACK FOOTER //
// ./src/store.js